var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDsl = function SvgDsl(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#56F596",
    d: "M8 8.6H5v3h3v1.2H3.8v-6H5v.6h3zM5.6 3.2v1.2H3.2V3.2zM6.8 2H2v3.6h4.8zm6 5.4v1.2h-2.4V7.4zM14 6.2H9.2v3.6H14zm-1.2 5.4v1.2h-2.4v-1.2zm1.2-1.2H9.2V14H14z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDsl);
export { ForwardRef as ReactComponent };